import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/erp/imei-check-erp'

export const getImeiCheckErp = async (params) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response
}
